export const whQtyTableTypes = {
	qty_size_split: { name: "Qty Size Split", key: "qty_size_split" },
	channel_wh_qty_split: { name: "Channel Wh Qty Split", key: "channel_wh_qty_split" },
};
